// src/store/slices/categorySlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCategories } from '../../api';

export const fetchCategories = createAsyncThunk(
  'categories/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      
      const categories = await getCategories();
      
      
      
      // getCategories() now returns the actual data array directly
      return categories;
    } catch (err) {
      console.error('Failed to fetch categories:', err);
      return rejectWithValue({
        message: err.message || 'Failed to load categories',
        status: err.status,
        timestamp: new Date().toISOString(),
      });
    }
  }
);

// Additional async thunk for retrying failed requests
export const retryFetchCategories = createAsyncThunk(
  'categories/retryFetch',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const categories = await getCategories();
      return categories;
    } catch (err) {
      console.error('Retry failed to fetch categories:', err);
      return rejectWithValue({
        message: err.message || 'Failed to load categories after retry',
        status: err.status,
        timestamp: new Date().toISOString(),
      });
    }
  }
);

const categorySlice = createSlice({
  name: 'categories',
  initialState: {
    list: [],
    loading: false,
    error: null,
    lastFetched: null,
    retryCount: 0,
    isRetrying: false,
  },
  reducers: {
    clearCategoriesError: (state) => {
      state.error = null;
    },
    resetCategories: (state) => {
      state.list = [];
      state.loading = false;
      state.error = null;
      state.lastFetched = null;
      state.retryCount = 0;
      state.isRetrying = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchCategories cases
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.isRetrying = false;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        console.log('Categories fetched successfully:', action.payload);
        console.log('Categories payload type:', typeof action.payload);
        console.log('Categories payload isArray:', Array.isArray(action.payload));
        state.loading = false;
        state.list = action.payload;
        state.error = null;
        state.lastFetched = new Date().toISOString();
        state.retryCount = 0;
        state.isRetrying = false;
        console.log('Categories state after update:', state);
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.retryCount += 1;
        state.isRetrying = false;
      })
      // retryFetchCategories cases
      .addCase(retryFetchCategories.pending, (state) => {
        state.loading = true;
        state.isRetrying = true;
      })
      .addCase(retryFetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
        state.error = null;
        state.lastFetched = new Date().toISOString();
        state.retryCount = 0;
        state.isRetrying = false;
      })
      .addCase(retryFetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.retryCount += 1;
        state.isRetrying = false;
      });
  },
});

export const { clearCategoriesError, resetCategories } = categorySlice.actions;
export default categorySlice.reducer;
